import Vue from 'vue'
import Vuex from 'vuex'
// import 'normalize.css/normalize.css'

import './assets/css/border.css'
import './assets/css/animate.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './components/install'
import '@babel/polyfill';
import './api'
// import './mock'
import './utils/api'
// import umfMessage from './components/umfMessage'
import vueToTop from 'vue-totop'

import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)

Vue.use(vueToTop)
Vue.use(Vuex)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')